import React from "react";
import "./styles.css";
import QuestionsImage from "../../assets/img/questions.png";
import { productQuestionsArray } from "../../constants/contents";

function ProductQuestions() {
  return (
    <div className="product-questions">
      <div className="product-questions__intro">
        <h1>
          ¿Tu atención al cliente por WhatsApp es muy desorganizada y caótica?
        </h1>
        <img src={QuestionsImage} alt="woman with questions" />
      </div>
      <ul>
        {productQuestionsArray.map((productQuestion) => (
          <li>{productQuestion}</li>
        ))}
      </ul>
    </div>
  );
}

export default ProductQuestions;
